$("a[href^='#']:not(.button):not(.tooltip-icon):not(.tooltip-link):not([href='#chatbot'])").on('click', function (e) {
    e.preventDefault();
    const anchorId =  $(this).attr('href');
    const $customerSwitcher = $('.customer-switcher');
    const headerHeight = $(".header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

    if(anchorId && anchorId.startsWith('#') && anchorId !== '#') {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(anchorId).offset().top - headerHeight
        }, 300);
    }
});

$(document).on('click', 'a[href="#chatbot"]', function (e) {
    e.preventDefault();

    if (window.hsag_chatbot && window.hsag_chatbot.api && typeof window.hsag_chatbot.api.startDialog === 'function') {
        window.hsag_chatbot.api.startDialog();
    }
});